import { COLUMN_SIZE } from '../DataGridDevEx/DataGrid.constants';

export const getPickSlipLookupColumns = () => [
    {
        dataField: 'SalesEntity',
        caption: 'Entity',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'Invoice',
        caption: 'Invoice',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'DespatchNumber',
        caption: 'Despatch',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ProductGrupField,
        width: COLUMN_SIZE.ProductGrupField,
        fixed: false
    },
    {
        dataField: 'Warehouse',
        caption: 'W/H',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        fixed: false
    },
    {
        dataField: 'CustomerPO',
        caption: 'Customer P/O',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
    {
        dataField: 'SiteCode',
        caption: 'Site code',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: false
    },
    {
        dataField: 'City',
        caption: 'City',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
    {
        dataField: 'SendVia',
        caption: 'Send via',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: false
    },
    {
        dataField: 'FinalisedDisplay',
        caption: 'Finalised',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        fixed: false
    },
    {
        dataField: 'CustomerAbbreviation',
        caption: 'Customer name',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
];
export const getPickSlipLookupSearchColumns = () => [
    {
        dataField: 'SalesEntity',
        caption: 'Entity',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'Invoice',
        caption: 'Invoice',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'DespatchNumber',
        caption: 'Despatch',
        allowResizing: true,
        minWidth: COLUMN_SIZE.ProductGrupField,
        width: COLUMN_SIZE.ProductGrupField,
        fixed: false
    },
    {
        dataField: 'Warehouse',
        caption: 'W/H',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        fixed: false
    },
    {
        dataField: 'CustomerPO',
        caption: 'Customer P/O',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
    {
        dataField: 'SiteCode',
        caption: 'Site code',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: false
    },
    {
        dataField: 'City',
        caption: 'City',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
    {
        dataField: 'SendVia',
        caption: 'Send via',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: false
    },
    {
        dataField: 'FinalisedDisplay',
        caption: 'Finalised',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        fixed: false
    },
    {
        dataField: 'CustomerAbbreviation',
        caption: 'Customer name',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
];
export const SEARCH_SCREEN_DIALOG_STYLE = {
    width: 'calc(71%)',
    maxWidth: 'calc(71%)',
    height: 'calc(100% - 300px)',
    maxHeight: 'calc(100% - 300px)',
};
